// Guards for Site Content elements based on getSiteContentElementListingQuery

import {
    LinkCollectionEntry,
    LinkCollectionEntryExternal,
    LinkCollectionEntryInternal,
    ImageLinkCollectionEntry,
    ImageLinkCollectionEntryExternal,
    ImageLinkCollectionEntryInternal,
    CompanyFocusTopicElementEntry,
    CompanyFocusTopicContentSectionEntry,
    CompanyFocusTopicExternalLinkEntry,
    CompanyFocusTopicInternalLinkEntry,
} from '../types/SiteContentElement';

// LinkCollection entries

export function isLinkCollectionEntryExternal(
    entry: LinkCollectionEntry
): entry is LinkCollectionEntryExternal {
    return entry.kind === 'externalLinkFieldCollection';
}

export function isLinkCollectionEntryInternal(
    entry: LinkCollectionEntry
): entry is LinkCollectionEntryInternal {
    return entry.kind === 'internalLinkFieldCollection';
}

// ImageLinkCollection entries

export function isImageLinkCollectionEntryExternal(
    entry: ImageLinkCollectionEntry
): entry is ImageLinkCollectionEntryExternal {
    return entry.kind === 'externalImageLinkFieldCollection';
}

export function isImageLinkCollectionEntryInternal(
    entry: ImageLinkCollectionEntry
): entry is ImageLinkCollectionEntryInternal {
    return entry.kind === 'internalImageLinkFieldCollection';
}

// CompanyFocusTopic entries

export function isCompanyFocusTopicContentSectionEntry(
    entry: CompanyFocusTopicElementEntry
): entry is CompanyFocusTopicContentSectionEntry {
    return entry.kind === 'contentSectionFieldCollection';
}

export function isCompanyFocusTopicExternalLinkEntry(
    entry: CompanyFocusTopicElementEntry
): entry is CompanyFocusTopicExternalLinkEntry {
    return entry.kind === 'externalLinkFieldCollection';
}

export function isCompanyFocusTopicInternalLinkEntry(
    entry: CompanyFocusTopicElementEntry
): entry is CompanyFocusTopicInternalLinkEntry {
    return entry.kind === 'internalLinkFieldCollection';
}
